// ----------------------------------------------------------------------
// <copyright file="Izenda.MyPreferenceFirstName.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function () {

  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');  
  var AccountConstants = require('logic/data/Izenda.AccountConstants');
  var Input = require('share/components/controls/Izenda.Input');
  var Validator = require('share/components/hoc/Izenda.Validator');
  var ValidatableInput = Validator()(Input);
  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  var ObservablePropTypes = require('mobx-react').propTypes;
  var actions = require('./Izenda.MyPreferenceActions');

  var MyPreferenceFirstName = function (props) {
    var currentUser = props.store.model;
    var localization = props.localization;

    return (
      <GridLayout.Row>
        <GridLayout.Col cols='2'>
          <span className='validation required u_controlHeight control-label'>{localization.getText('USER_SETUP_LABEL_FIRST_NAME')}</span>
        </GridLayout.Col>
        <GridLayout.Col cols='10'>
          <ValidatableInput field="firstName"
                            className="form-control"
                            value={currentUser.firstName}
                            validations={AccountConstants.CONSTRAINTS.firstName}
                            onChange={this.props.updateValue.bind(this.props, "firstName")} />
        </GridLayout.Col>
      </GridLayout.Row>
    );
  };

  MyPreferenceFirstName.propTypes = {
    store: ObservablePropTypes.observableObject.isRequired
  };

  module.exports = connect(actions)(MyPreferenceFirstName);
})();


// WEBPACK FOOTER //
// ./ui/modules/MyProfile/MyPreference/Izenda.MyPreferenceFirstName.jsx